<template>
  <div class="upload-progress-bar">
    <div v-if="countProgress" class="progress-note">
      <LoadingIndicator class="note-spinner" />
      {{noteLabel}}
    </div>

    <div class="progress-line-wrap">
      <div class="progress-line">
        <div
          class="progress-inner"
          :style="{ transform: `scaleX(${scale})` }"
        ></div>
      </div>

      <div class="progress-label">{{percentLabel}}</div>
    </div>
  </div>
</template>

<script>
import { clamp } from '@/utils';
import LoadingIndicator from '@/components/LoadingIndicator';

export default {
  name: 'UploadProgressBar',

  props: {
    countProgress: {
      type: Object,
      default: () => ({}),
    },

    sizeProgress: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    noteLabel() {
      const { current, total } = this.countProgress;

      if (current >= 0 && total >= 0) {
        return `Subiendo ${clamp(current + 1, 1, total)} de ${total}…`;
      }

      return '';
    },

    scale() {
      const progressKeys = Object.keys(this.sizeProgress);

      if (!progressKeys.length) {
        return 0;
      }

      const accumulatedTotal = progressKeys.reduce((acc, key) => {
        const totalSize = this.sizeProgress[key].total || 0;

        return acc + totalSize;
      }, 0);

      const accumulatedLoaded = progressKeys.reduce((acc, key) => {
        const loadedSize = this.sizeProgress[key].loaded || 0;

        return acc + loadedSize;
      }, 0);

      const ratio = accumulatedLoaded / accumulatedTotal;

      return clamp(Math.round(ratio * 100) / 100, 0, 1);
    },

    percentLabel() {
      return `${Math.floor(this.scale * 100)}%`;
    },
  },

  components: {
    LoadingIndicator,
  },
};
</script>

<style lang="scss" scoped>
.upload-progress-bar {
  width: 320px;
  max-width: 100%;
}

.progress-note {
  margin-bottom: 4px;
  font-size: 12px;
  display: flex;
  align-items: flex-end;

  .note-spinner {
    margin-right: 6px;
    font-size: 7px;
  }
}

.progress-line-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.progress-line {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  background: var(--bf-color-grey--light);
}

.progress-inner {
  height: 100%;
  width: 100%;
  transform-origin: left center;
  background: var(--bf-color-primary);
  transition: transform .2s linear;
  will-change: transform;
}

.progress-label {
  font-size: 12px;
  min-width: 31px;
  text-align: right;
  margin-left: 10px;
}
</style>
